export default function ContactFormField({ id, label, error, as: Control = "input", ...props }) {
  const errorMessage = Array.isArray(error) ? error.join(" ") : error;
  const controlClass = Control === "select" ? "form-select" : "form-control";
  const textareaClass = Control === "textarea" ? " public-contact-form__control--textarea" : "";

  return (
    <div>
      <label className="public-contact-form__label" htmlFor={id}>{label}</label>
      <Control
        {...props}
        id={id}
        className={`${controlClass} public-contact-form__control${textareaClass}`}
        aria-invalid={Boolean(errorMessage)}
        aria-describedby={errorMessage ? `${id}-error` : undefined}
      />
      {errorMessage ? <div id={`${id}-error`} className="public-contact-form__error">{errorMessage}</div> : null}
    </div>
  );
}
